import { makeStyles, TableCell, withStyles } from '@material-ui/core'
import colors from '../../../../../assets/colors'

export const useStyles = makeStyles({
  '@keyframes pulseAnimation': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.5,
    },
    '100%': {
      opacity: 1,
    },
  },
  container: {
    borderRadius: '1rem',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.1)',
    width: '100%',
    padding: '1rem',
  },
  subContainer: {
    borderRadius: '1rem',
    border: '1px solid',
    borderColor: colors.grayMedium,
    borderStyle: 'dashed',
    width: '100%',
    padding: '1rem',
  },
  simpleText: {
    color: colors.grayMedium,
    fontStyle: 'italic',
  },
  downloadBtn: {
    padding: 0,
    margin: 0,
    color: colors.primary,
    animation: `$pulseAnimation 2s infinite ease-in-out`,
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  tableContainer: {
    border: '1px solid',
    borderColor: colors.graylight,
    borderRadius: '4px',
    padding: '8px 0',
  },
  importBtn: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: colors.lightGray,
    boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.1)',
    padding: '8px',
    color: colors.gray,
    '&:hover': {
      backgroundColor: 'inherit',
      animation: `$pulseAnimation 2s infinite ease-in-out`,
    },
  },
})

export const StyledCellHeaderCSV = withStyles(theme => ({
  head: {
    backgroundColor: '#FFFF',
    color: colors.gray,
    padding: '0',
    border: 'none',
  },
  body: {
    fontWeight: 400,
    fontSize: 14,
  },
}))(TableCell)

export const StyledCelBodyCSV = withStyles(theme => ({
  head: {
    backgroundColor: '#FFFF',
  },
  body: {
    color: colors.gray,
    border: '0',
    fontWeight: 400,
    fontSize: 14,
    padding: '4px 8px',
  },
}))(TableCell)
